// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tournament Live Events Styles */
.tournament-live-events {
  background-color: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  padding: 20px;
}

.live-events-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--border-primary);
}

.live-events-header h3 {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--text-primary);
}

.connection-indicator {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  background-color: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  font-weight: 500;
}

.connection-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  transition: all var(--transition-fast);
}

.connection-dot.connected {
  background-color: #10b981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
  animation: pulse-green 2s infinite;
}

.connection-dot.disconnected {
  background-color: #ef4444;
  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);
  animation: pulse-red 2s infinite;
}

.connection-text {
  color: var(--text-secondary);
  font-size: 0.75rem;
  font-weight: 500;
}

@keyframes pulse-green {
  0%, 100% {
    box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);
  }
}

@keyframes pulse-red {
  0%, 100% {
    box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);
  }
  50% {
    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
  }
}

/* Live Stats Header */
.live-stats-header {
  margin-bottom: 16px;
}

.tournament-info {
  margin-bottom: 12px;
}

.tournament-name {
  margin: 0 0 8px 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
}

.tournament-meta {
  display: flex;
  gap: 12px;
  align-items: center;
}

.tournament-status {
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.tournament-status.active {
  background-color: rgba(16, 185, 129, 0.1);
  color: #10b981;
}

.tournament-status.live {
  background-color: rgba(239, 68, 68, 0.1);
  color: #ef4444;
}

.tournament-status.draft {
  background-color: rgba(156, 163, 175, 0.1);
  color: #9ca3af;
}

.tournament-pot {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--proskins-green);
}

.live-stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.current-play {
  text-align: center;
}

.current-play-label {
  font-size: 0.875rem;
  color: var(--text-secondary);
  margin-bottom: 8px;
  font-weight: 600;
}

.round-hole-info {
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
}

.round-badge, .hole-badge {
  padding: 8px 12px;
  background-color: var(--proskins-green);
  color: white;
  border-radius: var(--radius-md);
  font-size: 1rem;
  font-weight: 700;
  min-width: 40px;
  text-align: center;
}

.not-started {
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-style: italic;
}

.stats-row {
  display: flex;
  gap: 12px;
}

.stat-item {
  flex: 1 1;
  text-align: center;
  background: var(--bg-card);
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-md);
  padding: 16px;
  box-shadow: var(--shadow-sm);
}

.stat-label {
  font-size: 0.75rem;
  color: var(--text-secondary);
  margin-bottom: 4px;
  font-weight: 500;
}

.stat-value {
  font-size: 1.25rem;
  font-weight: 700;
}

.stat-value.skins {
  color: var(--proskins-green);
}

.stat-value.sawoffs {
  color: #f59e0b;
}

/* Player Skins Table */
.player-skins-table {
  margin-top: 16px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.table-header h4 {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text-primary);
}

.player-count {
  font-size: 0.75rem;
  color: var(--text-secondary);
}

.table-container {
  border: 1px solid var(--border-primary);
  border-radius: var(--radius-md);
}

.skins-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.skins-table th {
  background-color: var(--bg-secondary);
  padding: 8px 12px;
  text-align: left;
  font-weight: 600;
  color: var(--text-primary);
  border-bottom: 1px solid var(--border-primary);
  position: sticky;
  top: 0;
  z-index: 10;
}

.skins-table td {
  padding: 8px 12px;
  border-bottom: 1px solid var(--border-secondary);
  vertical-align: top;
}

.skins-table tr:hover {
  background-color: var(--bg-secondary);
}

.player-cell {
  min-width: 120px;
}

.player-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.player-name {
  font-weight: 600;
  color: var(--text-primary);
  font-size: 0.875rem;
}

.tier-badge {
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  font-size: 0.625rem;
  font-weight: 600;
  text-transform: uppercase;
  width: fit-content;
}

.tier-badge.tier-a {
  background-color: #fbbf24;
  color: #000000;
}

.tier-badge.tier-b {
  background-color: #3b82f6;
  color: #ffffff;
}

.tier-badge.tier-c {
  background-color: #f97316;
  color: #ffffff;
}

.tier-badge.tier-d {
  background-color: #ef4444;
  color: #ffffff;
}

.skins-cell, .percentage-cell {
  text-align: center;
  min-width: 60px;
}

.skins-count {
  font-weight: 700;
  color: var(--proskins-green);
  font-size: 1rem;
}

.percentage-value {
  font-weight: 600;
  color: var(--text-primary);
}

.wins-cell {
  min-width: 100px;
}

.wins-list {
  font-size: 0.75rem;
  color: var(--text-secondary);
  font-family: monospace;
}

.scroll-indicator {
  padding: 8px 12px;
  text-align: center;
  background-color: var(--bg-secondary);
  border-top: 1px solid var(--border-primary);
  font-size: 0.75rem;
  color: var(--text-secondary);
}

/* Loading States */
.live-stats-loader {
  padding: 40px 20px;
  text-align: center;
}

.loader-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.spinner {
  width: 32px;
  height: 32px;
  border: 3px solid var(--border-primary);
  border-top: 3px solid var(--proskins-green);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.live-stats-error {
  padding: 20px;
  text-align: center;
  background-color: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: var(--radius-md);
  margin: 16px 0;
}

.live-stats-error p {
  margin: 0 0 12px 0;
  color: #dc2626;
  font-weight: 500;
}

.retry-button {
  background: linear-gradient(135deg, var(--proskins-green), var(--proskins-green-dark));
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: var(--radius-md);
  font-weight: 600;
  cursor: pointer;
  transition: all var(--transition-fast);
  font-size: 0.875rem;
}

.retry-button:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-glow);
}

.waiting-for-stats {
  padding: 40px 20px;
  text-align: center;
  color: var(--text-secondary);
}

.waiting-for-stats p {
  margin: 0 0 8px 0;
  font-size: 1rem;
  font-weight: 500;
}

.waiting-subtitle {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.no-tournament-selected {
  padding: 40px 20px;
  text-align: center;
  color: var(--text-secondary);
}

.no-tournament-selected p {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}

.no-players {
  padding: 20px;
  text-align: center;
  color: var(--text-secondary);
  font-style: italic;
}

/* Responsive Design */
@media (max-width: 768px) {
  .live-stats-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  
  .stats-row {
    flex-direction: column;
    gap: 8px;
  }
  
  .tournament-meta {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  
  .skins-table {
    font-size: 0.75rem;
  }
  
  .skins-table th,
  .skins-table td {
    padding: 6px 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TournamentLiveEvents/TournamentLiveEvents.css"],"names":[],"mappings":"AAAA,kCAAkC;AAClC;EACE,gCAAgC;EAChC,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;EAC5C,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,0BAA0B;EAC1B,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,8CAA8C;EAC9C,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sFAAsF;EACtF,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,gBAAgB;EAClB;AACF","sourcesContent":["/* Tournament Live Events Styles */\n.tournament-live-events {\n  background-color: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-md);\n  padding: 20px;\n}\n\n.live-events-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--border-primary);\n}\n\n.live-events-header h3 {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.connection-indicator {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 8px;\n  background-color: var(--bg-secondary);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.connection-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  transition: all var(--transition-fast);\n}\n\n.connection-dot.connected {\n  background-color: #10b981;\n  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);\n  animation: pulse-green 2s infinite;\n}\n\n.connection-dot.disconnected {\n  background-color: #ef4444;\n  box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);\n  animation: pulse-red 2s infinite;\n}\n\n.connection-text {\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n@keyframes pulse-green {\n  0%, 100% {\n    box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);\n  }\n  50% {\n    box-shadow: 0 0 0 4px rgba(16, 185, 129, 0.1);\n  }\n}\n\n@keyframes pulse-red {\n  0%, 100% {\n    box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2);\n  }\n  50% {\n    box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);\n  }\n}\n\n/* Live Stats Header */\n.live-stats-header {\n  margin-bottom: 16px;\n}\n\n.tournament-info {\n  margin-bottom: 12px;\n}\n\n.tournament-name {\n  margin: 0 0 8px 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.tournament-meta {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.tournament-status {\n  padding: 2px 6px;\n  border-radius: var(--radius-sm);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.tournament-status.active {\n  background-color: rgba(16, 185, 129, 0.1);\n  color: #10b981;\n}\n\n.tournament-status.live {\n  background-color: rgba(239, 68, 68, 0.1);\n  color: #ef4444;\n}\n\n.tournament-status.draft {\n  background-color: rgba(156, 163, 175, 0.1);\n  color: #9ca3af;\n}\n\n.tournament-pot {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--proskins-green);\n}\n\n.live-stats-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.current-play {\n  text-align: center;\n}\n\n.current-play-label {\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.round-hole-info {\n  display: flex;\n  gap: 4px;\n  justify-content: center;\n  align-items: center;\n}\n\n.round-badge, .hole-badge {\n  padding: 8px 12px;\n  background-color: var(--proskins-green);\n  color: white;\n  border-radius: var(--radius-md);\n  font-size: 1rem;\n  font-weight: 700;\n  min-width: 40px;\n  text-align: center;\n}\n\n.not-started {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-style: italic;\n}\n\n.stats-row {\n  display: flex;\n  gap: 12px;\n}\n\n.stat-item {\n  flex: 1;\n  text-align: center;\n  background: var(--bg-card);\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-md);\n  padding: 16px;\n  box-shadow: var(--shadow-sm);\n}\n\n.stat-label {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.stat-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n\n.stat-value.skins {\n  color: var(--proskins-green);\n}\n\n.stat-value.sawoffs {\n  color: #f59e0b;\n}\n\n/* Player Skins Table */\n.player-skins-table {\n  margin-top: 16px;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.table-header h4 {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.player-count {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n.table-container {\n  border: 1px solid var(--border-primary);\n  border-radius: var(--radius-md);\n}\n\n.skins-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.skins-table th {\n  background-color: var(--bg-secondary);\n  padding: 8px 12px;\n  text-align: left;\n  font-weight: 600;\n  color: var(--text-primary);\n  border-bottom: 1px solid var(--border-primary);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.skins-table td {\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--border-secondary);\n  vertical-align: top;\n}\n\n.skins-table tr:hover {\n  background-color: var(--bg-secondary);\n}\n\n.player-cell {\n  min-width: 120px;\n}\n\n.player-info {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.player-name {\n  font-weight: 600;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n}\n\n.tier-badge {\n  padding: 2px 6px;\n  border-radius: var(--radius-sm);\n  font-size: 0.625rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  width: fit-content;\n}\n\n.tier-badge.tier-a {\n  background-color: #fbbf24;\n  color: #000000;\n}\n\n.tier-badge.tier-b {\n  background-color: #3b82f6;\n  color: #ffffff;\n}\n\n.tier-badge.tier-c {\n  background-color: #f97316;\n  color: #ffffff;\n}\n\n.tier-badge.tier-d {\n  background-color: #ef4444;\n  color: #ffffff;\n}\n\n.skins-cell, .percentage-cell {\n  text-align: center;\n  min-width: 60px;\n}\n\n.skins-count {\n  font-weight: 700;\n  color: var(--proskins-green);\n  font-size: 1rem;\n}\n\n.percentage-value {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.wins-cell {\n  min-width: 100px;\n}\n\n.wins-list {\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n  font-family: monospace;\n}\n\n.scroll-indicator {\n  padding: 8px 12px;\n  text-align: center;\n  background-color: var(--bg-secondary);\n  border-top: 1px solid var(--border-primary);\n  font-size: 0.75rem;\n  color: var(--text-secondary);\n}\n\n/* Loading States */\n.live-stats-loader {\n  padding: 40px 20px;\n  text-align: center;\n}\n\n.loader-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid var(--border-primary);\n  border-top: 3px solid var(--proskins-green);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.live-stats-error {\n  padding: 20px;\n  text-align: center;\n  background-color: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: var(--radius-md);\n  margin: 16px 0;\n}\n\n.live-stats-error p {\n  margin: 0 0 12px 0;\n  color: #dc2626;\n  font-weight: 500;\n}\n\n.retry-button {\n  background: linear-gradient(135deg, var(--proskins-green), var(--proskins-green-dark));\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  font-size: 0.875rem;\n}\n\n.retry-button:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-glow);\n}\n\n.waiting-for-stats {\n  padding: 40px 20px;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n.waiting-for-stats p {\n  margin: 0 0 8px 0;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.waiting-subtitle {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.no-tournament-selected {\n  padding: 40px 20px;\n  text-align: center;\n  color: var(--text-secondary);\n}\n\n.no-tournament-selected p {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n.no-players {\n  padding: 20px;\n  text-align: center;\n  color: var(--text-secondary);\n  font-style: italic;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .live-stats-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  \n  .stats-row {\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .tournament-meta {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n  \n  .skins-table {\n    font-size: 0.75rem;\n  }\n  \n  .skins-table th,\n  .skins-table td {\n    padding: 6px 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
